// extracted by mini-css-extract-plugin
export default {"-large":"fmMdVtzvqZbsuRJE9I_w","container":"IC2mQGnHEjOM9ftUbxn7"};